import React, {Component} from 'react';
import {connect} from 'react-redux';

import LectureDescription from './LectureDescription';

import '../../styles/lecture/LectureTab.css';

class LectureTab extends Component {
    render() {
        let {description, isManager} = this.props;

        if (!description) {
            description = isManager ? '尚未填写课程介绍 好的介绍能提高课程购买率' : '只有一种稳赚不赔的投资，就是学习';
        }
        return (
            <div>
                <div className="lecture-all">
                    <LectureDescription description={description} />
                </div>
            </div>
        );
    }
}

export default connect((state) => ({
    description: state.lecture.lecture.description,
    isManager: state.lecture.role.is_manager,
}))(LectureTab);


// WEBPACK FOOTER //
// ./src/components/lecture/LectureTab.js